import script from "./HlbServiceTransferStatsView.vue?vue&type=script&setup=true&lang=js"
export * from "./HlbServiceTransferStatsView.vue?vue&type=script&setup=true&lang=js"

import "./HlbServiceTransferStatsView.vue?vue&type=style&index=0&id=33526e8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33526e8e"]])

export default __exports__